// extracted by mini-css-extract-plugin
export var brand = "_11-9";
export var button = "_11-0";
export var chevron = "_11-v";
export var chevronButton = "_11-w";
export var content = "_11-n";
export var danger = "_11-g";
export var dangerOutlined = "_11-h";
export var dark = "_11-l";
export var darkTheme = "_11-c";
export var extraSmall = "_11-4";
export var fullWidth = "_11-8";
export var ghost = "_11-d";
export var gray = "_11-t";
export var icon = "_11-p";
export var iconButton = "_11-s";
export var iconButtonBorder = "_11-x";
export var iconButtonBorderDark = "_11-y";
export var iconButtonBorderLight = "_11-z";
export var iconLeft = "_11-q";
export var iconRight = "_11-r";
export var large = "_11-1";
export var light = "_11-m";
export var medium = "_11-2";
export var micro = "_11-5";
export var nano = "_11-7";
export var outlined = "_11-k";
export var pending = "_11-a";
export var primary = "_11-i";
export var shadow = "_11-o";
export var small = "_11-3";
export var solidLight = "_11-e";
export var solidLightBrand = "_11-f";
export var spinner = "_11-u";
export var transparent = "_11-j";
export var warning = "_11-b";
export var wideNano = "_11-6";